import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';

function ContextAwareToggle({
  children, eventKey, callback, isFetching, isFetchingKey,
}) {
  const { activeEventKey } = useContext(AccordionContext);

  const handleClick = useAccordionButton(eventKey, () => {
    if (callback) callback(eventKey);
  });

  const isActive = (Array.isArray(activeEventKey) ? activeEventKey[0] : activeEventKey) === eventKey;
  const showSpinner = isFetching && isFetchingKey === eventKey;

  return (
    <button
      type="button"
      onClick={handleClick}
      className="fs-6 fw-normal d-flex justify-content-between w-100 border-0 bg-transparent"
    >
      {children}
      {showSpinner ? (
        <span
          className="spinner-border spinner-border-sm ms-2 text-success"
          role="status"
          aria-hidden="true"
        />
      ) : (
        <span className="text-white">{isActive ? 'Close' : 'Expand'}</span>
      )}
    </button>
  );
}

function ProjectIndexListGroup({
  count,
  classes,
  status,
  title,
  children,
  setCurrentActiveKey,
  isFetching,
  isFetchingKey,
}) {
  return (
    <Card className="mt-4" id={status}>
      <Card.Header as="div" className={classes}>
        <ContextAwareToggle
          eventKey={status}
          callback={setCurrentActiveKey}
          isFetching={isFetching}
          isFetchingKey={isFetchingKey}
        >
          <small role="button" tabIndex={0}>
            {title}
            {count > 0 && (
              <span className="badge rounded-pill bg-secondary ms-2">{count}</span>
            )}
          </small>
        </ContextAwareToggle>
      </Card.Header>
      <Accordion.Collapse eventKey={status}>
        <ul className="list-group list-group-hover">{children}</ul>
      </Accordion.Collapse>
    </Card>
  );
}

ProjectIndexListGroup.propTypes = {
  count: PropTypes.number,
  status: PropTypes.string.isRequired,
  title: PropTypes.string,
  classes: PropTypes.string,
  children: PropTypes.node.isRequired,
  setCurrentActiveKey: PropTypes.func,
  isFetching: PropTypes.bool,
  isFetchingKey: PropTypes.string,
};

ProjectIndexListGroup.defaultProps = {
  title: '',
  classes: '',
  count: 0,
  setCurrentActiveKey: () => {},
  isFetching: false,
  isFetchingKey: '',
};

export default ProjectIndexListGroup;
